import { Divider, Title } from '@mantine/core'
import { RoleAttributesApiDTO } from '../../../codegen/generated/Api.schemas'
import { RolePermissionCards } from './RolePermissionCards'

type InformationsRoleProps = {
  role: RoleAttributesApiDTO | undefined
}

export const InformationsRole = ({ role }: InformationsRoleProps) => {
  return (
    <>
      <Title>{role?.name}</Title>
      <Divider my="md" />
      <RolePermissionCards availableRoles={role?.permissions} readonly />
    </>
  )
}
